import type { Movie } from "@/types/movie";

export interface FilterOptions {
  category?: "movie" | "tv" | "all";
  genre?: string;
  region?: string;
  year?: number | "all";
  sort?: "heat" | "rating" | "year";
}

export function filterMovies(list: Movie[], options: FilterOptions): Movie[] {
  const { category = "all", genre = "全部", region = "全部", year = "all", sort = "heat" } = options;
  let result = list.filter((item) => {
    if (category !== "all" && item.category !== category) return false;
    if (genre !== "全部" && item.genre !== genre) return false;
    if (region !== "全部" && item.region !== region) return false;
    if (year !== "all" && item.year !== year) return false;
    return true;
  });
  result = [...result].sort((a, b) => {
    if (sort === "rating") return b.rating - a.rating;
    if (sort === "year") return b.year - a.year;
    return b.heat - a.heat;
  });
  return result;
}

export function searchMovies(list: Movie[], keyword: string): Movie[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return list.filter((item) => {
    const haystack = `${item.title}${item.genre}${item.region}${item.cast.join("")}${item.summary}`.toLowerCase();
    return haystack.includes(q);
  });
}

export function getMovieById(list: Movie[], id: string): Movie | undefined {
  return list.find((item) => item.id === id);
}

export function getRelated(list: Movie[], movie: Movie, limit = 6): Movie[] {
  return list
    .filter((item) => item.id !== movie.id && (item.genre === movie.genre || item.category === movie.category))
    .sort((a, b) => b.heat - a.heat)
    .slice(0, limit);
}

export function categoryLabel(category: string): string {
  return category === "tv" ? "电视剧" : "电影";
}